module.exports = __webpack_public_path__ + "img/app-txmh.bbaa015d.webp";